module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/introduces/08-a381b97325d062d2c44b1b97700e1e53.jpg";